/**
 * NavBadge — Badge for counts/status indicators in side nav items.
 * Story 13.2
 */

interface NavBadgeProps {
  count: number;
  /** Maximum display count before showing "N+" */
  max?: number;
}

export function NavBadge({ count, max = 99 }: NavBadgeProps) {
  if (count <= 0) return null;

  const display = count > max ? `${max}+` : String(count);

  return (
    <span
      className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-medium rounded-full bg-[var(--brand-primary)]/20 text-[var(--brand-primary)] transition-interactive"
      aria-label={`${count} items`}
    >
      {display}
    </span>
  );
}
